module.exports = __webpack_public_path__ + "img/ELearningTitleElementary.e4898860.png";